/**
 * @generated SignedSource<<06924d87e49e119830a9d25ad7019b99>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PatientBodyMeasurementsOutputFragmentInline$data = ReadonlyArray<{
  readonly node: {
    readonly bodyMassIndex: number | null;
    readonly date: any;
    readonly height: number | null;
    readonly id: string;
    readonly weight: number;
  };
  readonly " $fragmentType": "PatientBodyMeasurementsOutputFragmentInline";
}>;
export type PatientBodyMeasurementsOutputFragmentInline$key = ReadonlyArray<{
  readonly " $data"?: PatientBodyMeasurementsOutputFragmentInline$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientBodyMeasurementsOutputFragmentInline">;
}>;

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PatientBodyMeasurementsOutputFragmentInline"
};

(node as any).hash = "aa54f8a3229f5fb06e837d87ff6e4660";

export default node;
